import React from 'react';
import { Link } from 'react-router-dom';
export const Footer = () => {
  return <footer className="bg-gray-50 border-t border-gray-200 py-8" data-id="element-29">
      <div className="max-w-4xl mx-auto px-4" data-id="element-30">
        <div className="flex flex-col md:flex-row justify-between mb-6" data-id="element-31">
          <div className="mb-6 md:mb-0" data-id="element-32">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-33">QISS</h3>
            <p className="text-sm text-gray-600 max-w-xs" data-id="element-34">
              Geavanceerde haarhersteloplossingen speciaal ontworpen voor
              vrouwen van 35+
            </p>
          </div>
          <div data-id="element-35">
            <h4 className="font-medium text-gray-900 mb-2" data-id="element-36">Snelkoppelingen</h4>
            <ul className="text-sm space-y-1" data-id="element-37">
              <li data-id="element-38">
                <Link to="/adv" className="text-gray-600 hover:text-pink-600" data-id="element-39">
                  Ons Verhaal
                </Link>
              </li>
              <li data-id="element-40">
                <Link to="/pdp" className="text-gray-600 hover:text-pink-600" data-id="element-41">
                  Winkel
                </Link>
              </li>
              <li data-id="element-42">
                <a href="#" className="text-gray-600 hover:text-pink-600" data-id="element-43">
                  Reviews
                </a>
              </li>
              <li data-id="element-44">
                <a href="#" className="text-gray-600 hover:text-pink-600" data-id="element-45">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-46">
            <h4 className="font-medium text-gray-900 mb-2" data-id="element-47">Ondersteuning</h4>
            <ul className="text-sm space-y-1" data-id="element-48">
              <li data-id="element-49">
                <a href="#" className="text-gray-600 hover:text-pink-600" data-id="element-50">
                  FAQ
                </a>
              </li>
              <li data-id="element-51">
                <a href="#" className="text-gray-600 hover:text-pink-600" data-id="element-52">
                  Verzending
                </a>
              </li>
              <li data-id="element-53">
                <a href="#" className="text-gray-600 hover:text-pink-600" data-id="element-54">
                  Retourneren
                </a>
              </li>
              <li data-id="element-55">
                <a href="#" className="text-gray-600 hover:text-pink-600" data-id="element-56">
                  Privacybeleid
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="text-center text-xs text-gray-500 pt-4 border-t border-gray-200" data-id="element-57">
          <p data-id="element-58">
            © {new Date().getFullYear()} QISS Hair. Alle rechten voorbehouden.
          </p>
          <p className="mt-1" data-id="element-59">
            Deze website is alleen voor demonstratiedoeleinden. Geen echt
            product.
          </p>
        </div>
      </div>
    </footer>;
};